module.exports = __webpack_public_path__ + "static/media/nile shot 1.d832efba.webp";